import { GetRepairLaborsForTest } from "helpers/backend_helper"
import { useLoading } from "helpers/custom_hooks"
import React, { useEffect, useState } from "react"
import { Label, TabPane } from "reactstrap"

const RepairLaborTab = ({ nextTab, request, setRequest }) => {
  const [entries, setEntries] = useState([])
  const setLoading = useLoading()

  useEffect(() => {
    loadData()
  }, [])

  const loadData = async () => {
    const result = await GetRepairLaborsForTest(request?.repairOptionID)
    setEntries(result)
  }

  return (
    <TabPane tabId={2}>
      <h6 className="mb-4 card-title">Repair-Labors:</h6>
      <p>Please select a Repair Lab</p>
      <div className="controls mb-4">
        {entries.map((entry, index) => (
          <div className="form-check mb-2" key={index}>
            <input
              className="form-check-input"
              type="radio"
              name="repairLabor"
              id={"repair-labor" + entry.id}
              value={entry.id}
              onChange={() =>
                setRequest({ ...request, repairLaborID: entry.id })
              }
            />
            <Label
              className="form-check-label"
              htmlFor={"repair-labor" + entry.id}
            >
              {entry.name}
            </Label>
          </div>
        ))}

        <div className="d-flex justify-content-end">
          <button
            type="button"
            onClick={_ => nextTab(1)}
            disabled={!request?.repairLaborID}
            className="btn btn-primary"
          >
            Next
          </button>
        </div>
      </div>
    </TabPane>
  )
}

export default RepairLaborTab
